import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import { hasAuth } from "@/common/hooks/use_auth";
import GlobalContext from "models/globalContext";
import { useRouter } from "next/router";
import React, { useContext, useMemo } from "react";
import {
  MenuGroupItem,
  MenuItem,
  navigationMenuGroupMap,
} from "views/menu_layout/layout/config";

interface Props {
  children: React.ReactNode;
}

/** 校验页面权限 */
const CheckAuth = ({ children }: Props) => {
  const router = useRouter();
  const { resourceAuthList } = useContext(GlobalContext);

  const pageRoute = useMemo(() => {
    // 动态路由, 比如工具页面
    if (router.query.resourceCode) {
      return router.query.resourceCode as ResourceCodeEnums;
    }

    // 其他页面权限归属父级(如果有)路由
    return router.route.split("/")[1];
  }, [router.route, router.query]);

  const pageMenuItemList: MenuItem[] = useMemo(() => {
    return (
      navigationMenuGroupMap[pageRoute]
        ?.map((item: MenuGroupItem) => item.menuItemList)
        ?.flat() || []
    );
  }, [pageRoute]);

  const redirect = () => {
    // pageRoute或者pageRoute对应的导航下的菜单项, 只要有一个有权限, 则展示对应的页面
    const judgeAuthCodeList: string[] = [
      pageRoute,
      ...pageMenuItemList.map((item) => item.name),
    ];

    // 旧系统兼容逻辑在/pages/pro
    if (pageRoute === "pro") {
      return <div>{children}</div>;
    }

    /** --- 有权限 --- */
    // 如果页面下有一个菜单是一直展示的 或者 页面及其所有菜单项只要一个有权限, 则展示页面
    if (
      pageMenuItemList.some((item) => item.show) ||
      judgeAuthCodeList.some((item) =>
        resourceAuthList.find((auth) => auth.resourceCode === item)
      )
    ) {
      return <div>{children}</div>;
    }

    /** --- 无权限 --- */

    // 打开了home页面, 但没有home权限, 如果有人群管理页面权限, 则跳转人群管理;
    // 打开其他页面, 但没有权限则跳转到home页面
    // 没有home和人群管理权限则无动作
    if (
      pageRoute === ResourceCodeEnums.HOME &&
      hasAuth(resourceAuthList, ResourceCodeEnums.CUSTOM_LABEL, true)
    ) {
      router.push(
        `/${ResourceCodeEnums.CROWD}?menu=${ResourceCodeEnums.CUSTOM_LABEL}`
      );

      return null;
    } else if (pageRoute !== ResourceCodeEnums.HOME) {
      router.push("/home");

      return null;
    }

    return <div>{children}</div>;
  };

  return redirect();
};

export default CheckAuth;
